export const APPOINTMENTS_START_DATE_UNIX_KEY = "@lobbie/session/appointments/filter/start";
export const APPOINTMENTS_END_DATE_UNIX_KEY = "@lobbie/session/appointments/filter/end";
export const APPOINTMENTS_DISPLAYING_EVV_KEY = "@lobbie/session/appointments/filter/evv";
export const APPOINTMENTS_PATIENT_NAME_KEY = "@lobbie/session/appointments/filter/patient";
export const APPOINTMENTS_PRACTITIONER_ID_KEY = "@lobbie/session/appointments/filter/practitioner";
// TODO: payment what's the difference between Session and Local?
export const LOBBIE_STORAGE = {
    Session: {
        NPS: {
            Onboarding: {
                ShowSetUpSocialReviews: "@lobbie/social_nps/onboarding/showSetUpSocialReviews",
            },
        },
        Patients: {
            Forms: {
                Anonymous: {
                    AccountPublicUuid: "@lobbie/patients/forms/anonymous/AccountPublicUuid",
                    LocationId: "@lobbie/patients/forms/anonymous/LocationId",
                    FormTemplatePublicUuid:
                        "@lobbie/patients/forms/anonymous/FormTemplatePublicUuid",
                    FormTemplateGroupPublicUuid:
                        "@lobbie/patients/forms/anonymous/FormTemplateGroupPublicUuid",
                },
                ActiveFormGroupId: "@lobbie/patients/forms/ActiveFormGroupId",
                CacheKey: "@lobbie/patients/forms/CacheKey",
                S3ObjectPath: "@lobbie/patients/forms/S3ObjectPath",
                PageNumber: "@lobbie/patients/forms/PageNumber",
                NumberRow: "@lobbie/patients/forms/NumberRow",
                AnonymousCreated: "@lobbie/patients/forms/AnonymousCreated",
                AnonymousUpdateable: "@lobbie/patients/forms/AnonymousUpdateable",
                FormCompleted: "@lobbie/patients/forms/FormCompleted",
                VerifiedDateOfBirth: "@lobbie/patients/forms/VerifiedDateOfBirth",
            },
            Scheduler: {
                Practitioners_v2: "@lobbie/staff/scheduler/practitioners_v2",
                SelectedDay_v2: "@lobbie/staff/scheduler/selected/day_v2",
                SelectedDayTimezone_v2: "@lobbie/staff/scheduler/selected/day/timezone_v2",
                InitialAccountPatientId_v2:
                    "@lobbie/staff/scheduler/selected/day/InitialAccountPatientId_v2",
                ShowSchedulablePractitioners_v2:
                    "@lobbie/staff/scheduler/selected/day/ShowSchedulablePractitioners_v2",
            },
        },
        Staff: {
            Forms: {
                ExpandedRows: "@lobbie/staff/forms/ExpandedRows",
                Send: {
                    Start: "@lobbie/session/forms/filter/start",
                    End: "@lobbie/session/forms/filter/end",
                },
            },
            Patients: {
                PatientName: "@lobbie/staff/patients/PatientName",
                PageNumber: "@lobbie/staff/patients/PageNumber",
                NumberRow: "@lobbie/staff/patients/NumberRow",
            },
            Scheduler: {
                Practitioners_v2: "@lobbie/staff/scheduler/practitioners_v2",
                SelectedDay_v2: "@lobbie/staff/scheduler/selected/day_v2",
                SelectedDayTimezone_v2: "@lobbie/staff/scheduler/selected/day/timezone_v2",
                InitialAccountPatientId_v2:
                    "@lobbie/staff/scheduler/selected/day/InitialAccountPatientId_v2",
                ShowSchedulablePractitioners_v2:
                    "@lobbie/staff/scheduler/selected/day/ShowSchedulablePractitioners_v2",
                SchedulerView_v2: "@lobbie/staff/scheduler/currentView",
                SchedulerSelectedDate_v2: "@lobbie/staff/scheduler/currentDate",
                SchedulerSelectedMonth_v2: "@lobbie/staff/scheduler/currentMonth",
                SchedulerHiddenCals_v2: "@lobbie/staff/scheduler/hiddenCals",
            },
            Payments: {
                ExpandedRows: "@lobbie/staff/payments/ExpandedRows",
                Send: {
                    Start: "@lobbie/session/payments/filter/start",
                    End: "@lobbie/session/payments/filter/end",
                },
            },
            Settings: {
                SelfSchedulingSettingName: "@lobbie/staff/settings/SelfSchedulingSettingName",
            },
            Appointments: {
                Actions: {
                    TimeSelect: "@lobbie/staff/appts/actions/timeselect",
                    TimeStart: "@lobbie/staff/appts/actions/timestart",
                    TimeEnd: "@lobbie/staff/appts/actions/timeend",
                    CurrentView: "@lobbie/staff/appts/actions/currentview",
                    PatientView: "@lobbie/staff/appts/actions/patientview",
                    Canceled: "@lobbie/staff/appts/actions/canceled",
                    NoShow: "@lobbie/staff/appts/actions/noshow",
                    LongWait: "@lobbie/staff/appts/actions/longwait",
                    TableNumRows: "@lobbie/staff/appts/actions/table/numrows",
                    TablePageNum: "@lobbie/staff/appts/actions/table/pagenum",
                },
                Dashboard: {
                    PFilterText: "@lobbie/staff/appts/dashboard/pfiltertext",
                    FilterMine: "@lobbie/staff/appts/dashboard/myappts",
                    TimeStart: "@lobbie/staff/appts/dashboard/timestart",
                    TimeEnd: "@lobbie/staff/appts/dashboard/timeend",
                    Today: "@lobbie/staff/appts/dashboard/today",
                    TimeSelect: "@lobbie/staff/appts/dashboard/timeselect",
                },
            },
            Labs: {
                LabFilterText: "@lobbie/staff/labs/labfiltertext",
                SortSelectionKey: "@lobbie/staff/labs/sortselection",
                TrendStartDate: "@lobbie/staff/labs/labTrendStart",
                TrendEndDate: "@lobbie/staff/labs/labTrendEnd",
                TrendDateSelection: "@lobbie/staff/labs/labTrendDateSelection",
                TrendFilterText: "@lobbie/staff/labs/labTrendFilterText",
            },
        },
        Shared: {
            Forms: {
                SectionIndex: "@lobbie/shared/forms/SectionIndex",
            },
            Components: {
                Table: {
                    NumRows: "@lobbie/shared/components/table/numrows",
                    PageNum: "@lobbie/shared/components/table/pagenum",
                },
            },
        },
    },
    Local: {
        Banner: {
            Version: "@lobbie/banner/version",
        },
        Forms: {
            Drawable: {
                Signature: "@lobbie/forms/drawable/signature",
                Initials: "@lobbie/forms/drawable/initials",
            },
            Initials: "@lobbie/forms/initials",
            Signature: "@lobbie/forms/signature",
        },
        Locations: {
            Colors: "@lobbie/locations/colors",
            Location: {
                Name: "@lobbie/locations/location/name",
            },
        },
        Shared: {
            User: "@lobbie/user",
            UserType: "@lobbie/userType",
        },
        Staff: {
            PDF: {
                Zoom: "@lobbie/staff/pdf/zoom",
            },
            Signature: {
                Signature: "@lobbie/local/staff/signature/Signature",
            },
            Account: {
                ID: {
                    V2: "@lobbie/account/id/v2",
                },
            },
            Features: {
                PatientDetailsV2: "@lobbie/local/staff/features/PatientDetailsV2",
            },
            Location: {
                ID: {
                    V2: "@lobbie/location/id/v2",
                },
                TimeZone: {
                    V2: "@lobbie/location/timezone/v2",
                },
            },
            Locations: {
                Multiple: "@lobbie/locations/multiple/ids",
            },
            Forms: {
                FormStatus: "@lobbie/session/forms/filter/status",
                NumberRow: "@lobbie/staff/forms/NumberRow",
                DateRange: "@lobbie/staff/forms/DateRange",
                FormTemplateNames: "@lobbie/staff/forms/FormTemplateNames",
                LocationIds: "@lobbie/staff/forms/LocationIds",
                PractitionerId: "@lobbie/staff/forms/PractitionerId",
                PatientName: "@lobbie/staff/patients/PatientName",
                PageNumber: "@lobbie/staff/forms/PageNumber",
                SortField: "@lobbie/staff/forms/SortField",
                SortDirection: "@lobbie/staff/forms/SortDirection",
                CSV: {
                    IS_RESPECT_LOCATION_FILTER: "@lobbie/staff/forms/csv/isRespectLocationFilter",
                    IS_RESPECT_PATIENT_SEARCH_FILTER:
                        "@lobbie/staff/forms/csv/isRespectPatientSearch",
                    IS_RESPECT_TEMPLATE_FILTER: "@lobbie/staff/forms/csv/isRespectTemplatesFilter",
                    IS_RESPECT_PRACTITIONERS_FILTER:
                        "@lobbie/staff/forms/csv/isRespectPractitionersFilter",
                    IS_RESPECT_STATUS_FILTER: "@lobbie/staff/forms/csv/isRespectStatusFilter",
                    IS_RESPECT_DUE_DATE_FILTER: "@lobbie/staff/forms/csv/isRespectDueDateFilter",
                    IS_SHOW_CURRENT_AND_ARCHIVED_FILTER:
                        "@lobbie/staff/forms/csv/isShowCurrentAndArchived",
                    IS_INCLUDE_FORM_ANSWERS_FILTER: "@lobbie/staff/forms/csv/isIncludeFormAnswers",
                    IS_INCLUDE_FORM_ANSWERS_METADATA:
                        "@lobbie/staff/forms/csv/isIncludeFormAnswersMetadata",
                    IS_SINGLE_CSV: "@lobbie/staff/forms/csv/isSingleCSV",
                    IS_SELECTED_FORM_GROUPS: "@lobbie/staff/forms/csv/isRespectSelectedFormGroups",
                    IS_RESPECT_PAGINATION: "@lobbie/staff/forms/csv/isRespectPagination",
                },
            },
            Payments: {
                Requests: {
                    PatientName: "@lobbie/staff/payments/requests/PatientName",
                    Status: "@lobbie/staff/payments/requests/Status",
                    DueDateRange: "@lobbie/staff/payments/requests/DueDateRange",
                    StartDueDate: "@lobbie/staff/payments/requests/StartDueDate",
                    EndDueDate: "@lobbie/staff/payments/requests/EndDueDate",
                    FormStatus: "@lobbie/session/payments/filter/status",
                    NumberRow: "@lobbie/staff/payments/NumberRow",
                    DateRange: "@lobbie/staff/payments/DateRange",
                    LocationIds: "@lobbie/staff/payments/LocationIds",
                    PractitionerId: "@lobbie/staff/payments/PractitionerId",
                    // PatientName: "@lobbie/staff/patients/PatientName",
                    PageNumber: "@lobbie/staff/payments/PageNumber",
                    SortField: "@lobbie/staff/payments/SortField",
                    SortDirection: "@lobbie/staff/payments/SortDirection",
                },
                Invoice: {
                    PatientName: "@lobbie/staff/payments/invoice/PatientName",
                    Status: "@lobbie/staff/payments/invoice/Status",
                    FormStatus: "@lobbie/session/payments/invoice/filter/status",
                    NumberRow: "@lobbie/staff/payments/invoice/NumberRow",
                    DateRange: "@lobbie/staff/payments/invoice/DateRange",
                    PractitionerId: "@lobbie/staff/payments/invoice/PractitionerId",
                    PageNumber: "@lobbie/staff/payments/invoice/PageNumber",
                    SortField: "@lobbie/staff/payments/invoice/SortField",
                    SortDirection: "@lobbie/staff/payments/invoice/SortDirection",
                    CreatedDateRange: "@lobbie/staff/payments/invoice/CreatedDateRange",
                    DueDateRange: "@lobbie/staff/payments/invoice/DueDateRange",
                    StartCreatedDate: "@lobbie/staff/payments/invoice/StartCreatedDate",
                    EndCreatedDate: "@lobbie/staff/payments/invoice/EndCreatedDate",
                    StartDueDate: "@lobbie/staff/payments/invoice/StartDueDate",
                    EndDueDate: "@lobbie/staff/payments/invoice/EndDueDate",
                },
                Subscriptions: {
                    PatientName: "@lobbie/staff/payments/subscriptions/PatientName",
                    Status: "@lobbie/staff/payments/subscriptions/Status",
                    StartDate: "@lobbie/staff/payments/subscriptions/StartDate",
                    CareServiceIds: "@lobbie/staff/payments/subscriptions/CareServiceIds",
                    FormStatus: "@lobbie/session/payments/subscriptions/filter/status",
                    NumberRow: "@lobbie/staff/payments/subscriptions/NumberRow",
                    DateRange: "@lobbie/staff/payments/subscriptions/DateRange",
                    LocationIds: "@lobbie/staff/payments/subscriptions/LocationIds",
                    PractitionerId: "@lobbie/staff/payments/subscriptions/PractitionerId",
                    PageNumber: "@lobbie/staff/payments/subscriptions/PageNumber",
                    SortField: "@lobbie/staff/payments/subscriptions/SortField",
                    SortDirection: "@lobbie/staff/payments/subscriptions/SortDirection",
                },
            },
            Patients: {
                Details: {
                    Section: "@lobbie/staff/patients/details/Section",
                    FormId: "@lobbie/staff/patients/details/FormId",
                },
            },
            CSL: {
                Inventory: {
                    LocationIds: "@lobbie/staff/medication_inventory/LocationIds",
                    Search: "@lobbie/staff/medication_inventory/Search",
                    Status: "@lobbie/staff/medication_inventory/Status",
                    PageNumber: "@lobbie/staff/medication_inventory/PageNumber",
                    NumberRow: "@lobbie/staff/medication_inventory/NumberRow",
                    SortField: "@lobbie/staff/medication_inventory/SortField",
                    SortDirection: "@lobbie/staff/medication_inventory/SortDirection",
                },
                ContainerLog: {
                    LogType: "@lobbie/staff/csl/container_log/LogType",
                    LogStatus: "@lobbie/staff/csl/container_log/LogStatus",
                    DateRange: "@lobbie/staff/csl/container_log/DateRange",
                    StartOccurredOn: "@lobbie/staff/csl/container_log/StartOccurredOn",
                    EndOccurredOn: "@lobbie/staff/csl/container_log/EndOccurredOn",
                    // May return to this in future, LOBBIE-4217
                    // Medication: "@lobbie/staff/csl/container_log/Medication",
                    // Container: "@lobbie/staff/csl/container_log/Container",
                    // Patient: "@lobbie/staff/csl/container_log/Patient",
                    PageNumber: "@lobbie/staff/csl/container_log/PageNumber",
                    NumberRow: "@lobbie/staff/csl/container_log/NumberRow",
                    SortField: "@lobbie/staff/csl/container_log/SortField",
                    SortDirection: "@lobbie/staff/csl/container_log/SortDirection",
                },
                InventoryLog: {
                    LogType: "@lobbie/staff/csl/inventory_log/LogType",
                    LogStatus: "@lobbie/staff/csl/inventory_log/LogStatus",
                    DateRange: "@lobbie/staff/csl/inventory_log/DateRange",
                    StartOccurredOn: "@lobbie/staff/csl/inventory_log/StartOccurredOn",
                    EndOccurredOn: "@lobbie/staff/csl/inventory_log/EndOccurredOn",
                    // May return to this in future, LOBBIE-4217
                    // Medication: "@lobbie/staff/csl/inventory_log/Medication",
                    // Container: "@lobbie/staff/csl/inventory_log/Container",
                    // Patient: "@lobbie/staff/csl/inventory_log/Patient",
                    PageNumber: "@lobbie/staff/csl/inventory_log/PageNumber",
                    NumberRow: "@lobbie/staff/csl/inventory_log/NumberRow",
                    SortField: "@lobbie/staff/csl/inventory_log/SortField",
                    SortDirection: "@lobbie/staff/csl/inventory_log/SortDirection",
                },
                ReconciliationLog: {
                    DateRange: "@lobbie/staff/csl/reconciliation/DateRange",
                    FromISO: "@lobbie/staff/csl/reconciliation/FromISO",
                    ToISO: "@lobbie/staff/csl/reconciliation/ToISO",
                    PageNumber: "@lobbie/staff/csl/reconciliation/PageNumber",
                    RowsPerPage: "@lobbie/staff/csl/reconciliation/RowsPerPage",
                    SortField: "@lobbie/staff/csl/reconciliation/SortField",
                    SortDirection: "@lobbie/staff/csl/reconciliation/SortDirection",
                },
                ContainerArchive: {
                    PageNumber: "@lobbie/staff/csl/container_archive/PageNumber",
                    RowsPerPage: "@lobbie/staff/csl/container_archive/RowsPerPage",
                    SortField: "@lobbie/staff/csl/container_archive/SortField",
                    SortDirection: "@lobbie/staff/csl/container_archive/SortDirection",
                    // May return to this in future, LOBBIE-4217
                    // MedicationId: "@lobbie/staff/csl/container_archive/MedicationId",
                    // ContainerId: "@lobbie/staff/csl/container_archive/ContainerId",
                    // LotId: "@lobbie/staff/csl/container_archive/LotId",
                    // NDCVariantId: "@lobbie/staff/csl/container_archive/NDCVariantId",
                },
                ReconciliationDrawer: {
                    RowsPerPage: "@lobbie/staff/csl/reconciliation_search/RowsPerPage",
                },
                LotDetailsDrawer: {
                    RowsPerPage: "@lobbie/staff/csl/lot_detail/RowsPerPage",
                },
                ContainerDetailsDrawer: {
                    RowsPerPage: "@lobbie/staff/csl/lot_detail/RowsPerPage",
                },
            },
            ClinicalCharts: {
                ChartReview: {
                    PatientId: "@lobbie/staff/clinical_charts/chart_review/PatientId",
                    PageNumber: "@lobbie/staff/clinical_charts/chart_review/PageNumber",
                    RowsPerPage: "@lobbie/staff/clinical_charts/chart_review/RowsPerPage",
                    SortField: "@lobbie/staff/clinical_charts/chart_review/SortField",
                    SortDirection: "@lobbie/staff/clinical_charts/chart_review/SortDirection",
                    StartDate: "@lobbie/staff/clinical_charts/chart_review/StartDate",
                    EndDate: "@lobbie/staff/clinical_charts/chart_review/EndDate",
                    TimeframeOption: "@lobbie/staff/clinical_charts/chart_review/TimeframeOption",
                    AppointmentStatus:
                        "@lobbie/staff/clinical_charts/chart_review/AppointmentStatus",
                },
            },
        },
        Patient: {
            Forms: {
                Token: "@lobbie/patient/forms/Token",
            },
            Payments: {
                Token: "@lobbie/patient/payments/Token",
            },
        },
        Settings: {
            Integrations: {
                AppointmentTypes: {
                    ShowConfirmationModal:
                        "@lobbie/settings/integrations/appointment_types/show_confirmation_modal",
                },
                Locations: {
                    ShowConfirmationModal:
                        "@lobbie/settings/integrations/locations/show_confirmation_modal",
                },
                FormTemplates: {
                    ShowConfirmationModal:
                        "@lobbie/settings/integrations/form_templates/show_confirmation_modal",
                },
            },
            PractitionerScheduling: {
                View: "@lobbie/settings/practitioner_scheduling/PractitionersSchedulingView",
            },
            SchedulerConfig: {
                Name: "@lobbie/settings/scheduler_config/Name",
                PageNumber: "@lobbie/settings/scheduler_config/PageNumber",
                NumberRow: "@lobbie/settings/scheduler_config/NumberRow",
                SortField: "@lobbie/settings/scheduler_config/SortField",
                SortDirection: "@lobbie/settings/scheduler_config/SortDirection",
            },
            AppointmentType: {
                Name: "@lobbie/settings/appointment_type/Name",
                PageNumber: "@lobbie/settings/appointment_type/PageNumber",
                NumberRow: "@lobbie/settings/appointment_type/NumberRow",
                SortField: "@lobbie/settings/appointment_type/SortField",
                SortDirection: "@lobbie/settings/appointment_type/SortDirection",
            },
            Billing: {
                Services: {
                    Name: "@lobbie/settings/billing/services/Name",
                    PageNumber: "@lobbie/settings/billing/services/PageNumber",
                    NumberRow: "@lobbie/settings/billing/services/NumberRow",
                },
                Items: {
                    Name: "@lobbie/settings/billing/items/Name",
                    PageNumber: "@lobbie/settings/billing/items/PageNumber",
                    NumberRow: "@lobbie/settings/billing/items/NumberRow",
                },
            },
        },
    },
};
